import ReportPage from "../../Page/Report";

const Report = () => {
    return (
        <><ReportPage /></>
    )
}

export default Report;